export default __webpack_public_path__ + "static/media/Footpad's Jerkin of the Stolen Kingdom.8ca09b46.jpg";